module.exports = __webpack_public_path__ + "img/3.aabd6826.png";